export default "__VITE_ASSET__COlScpfe__"